var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "width": "800",
      "title": "编辑人员任务权限"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "userlist-wrapper"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索用户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchUser
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadUser
    }
  })], 1)]), _c('Table', {
    attrs: {
      "size": "small",
      "columns": _vm.taskCategoryColumns,
      "height": _vm.tableHeight,
      "border": "",
      "data": _vm.userList
    },
    scopedSlots: _vm._u([{
      key: "checkBox",
      fn: function (_ref) {
        var index = _ref.index,
          row = _ref.row,
          column = _ref.column;
        return [_vm.verifyTaskCategoryVisibleExistence(row, column) ? _c('Icon', {
          staticClass: "check-box",
          attrs: {
            "type": "md-checkbox",
            "color": "green",
            "size": "22"
          },
          on: {
            "click": function ($event) {
              return _vm.clickRoleCheckBox(index, column, false, row);
            }
          }
        }) : _c('Icon', {
          staticClass: "check-box",
          attrs: {
            "type": "md-square-outline",
            "color": "lightgray",
            "size": "22"
          },
          on: {
            "click": function ($event) {
              return _vm.clickRoleCheckBox(index, column, true, row);
            }
          }
        })];
      }
    }, {
      key: "grayCheckBox",
      fn: function (_ref2) {
        _vm._objectDestructuringEmpty(_ref2);
        return [_c('Icon', {
          attrs: {
            "type": "md-checkbox",
            "color": "gray",
            "size": "22"
          }
        })];
      }
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }